// extracted by mini-css-extract-plugin
module.exports = {"profileClaim":"ob_CTVJ67","profileClaim__header":"ob_RZXwO2","profileClaim__options":"ob_1j2TOC"};